(function () {
  function initSection(section) {
    if (!section || section.dataset.tabsInitialized === "true") return;

    const tabs = Array.from(section.querySelectorAll(".js-tab-title"));
    const contents = Array.from(section.querySelectorAll(".js-tab-content"));
    const collapsibleTitles = Array.from(section.querySelectorAll(".collapsible-tab-title"));

    if (tabs.length > 0 && contents.length > 0) {
      tabs.forEach((tab) => {
        tab.addEventListener("click", () => {
          const targetId = tab.getAttribute("data-tab");
          const target = document.getElementById(targetId);
          if (!target) return;

          tabs.forEach((t) => t.classList.remove("tab-active"));
          contents.forEach((c) => c.classList.remove("tab-content-active"));

          tab.classList.add("tab-active");
          target.classList.add("tab-content-active");
        });
      });
    }

    collapsibleTitles.forEach((title) => {
      title.addEventListener("click", () => {
        const parent = title.closest(".js-tab-content");
        if (!parent) return;

        contents.forEach((content) => {
          if (content !== parent) content.classList.remove("active");
        });
        parent.classList.toggle("active");
      });
    });

    const readMoreButton = section.querySelector(".js-btn-read-more");
    const descriptionContent = section.querySelector('[id^="product-description-"] .collapsible-tab-content');
    const actionWrap = section.querySelector(".collapsible-tab-action");

    if (readMoreButton && descriptionContent && actionWrap) {
      const syncReadMoreVisibility = function () {
        if (descriptionContent.scrollHeight > 431) {
          actionWrap.style.display = "flex";
        } else {
          actionWrap.style.display = "none";
        }
      };

      readMoreButton.addEventListener("click", () => {
        descriptionContent.classList.toggle("open");
      });

      syncReadMoreVisibility();
      window.setTimeout(syncReadMoreVisibility, 200);
    }

    section.dataset.tabsInitialized = "true";
  }

  function initAll(root) {
    const container = root || document;
    container.querySelectorAll(".section-product-tabs").forEach(initSection);
  }

  document.addEventListener("DOMContentLoaded", function () {
    initAll(document);
  });

  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });
})();
